import * as React from 'react';
import _ from 'lodash';

import { Dropdown, DropdownMenuItemType, IDropdownOption, IStyle } from '@fluentui/react';

export interface MultiSelectorProps {
  label?: string;
  placeholder?: string;
  items: { key: string; text: string }[];
  selectedKeys: string[];
  onChange: (keys: string[]) => void;
  hideAll?: boolean;
  disabled?: boolean;
  required?: boolean;
  styles?: IStyle;
  testId?: string;
}

export class MultiSelector extends React.Component<MultiSelectorProps> {
  public render(): JSX.Element {
    let options: IDropdownOption[] = this.props.hideAll ? [] : [{ key: 'ALL', text: 'All' }];
    if (this.props.items) {
      options = options.concat(this.props.items);
    }
    let selectedKeys = (this.props.selectedKeys || []).slice();

    if (!this.props.hideAll) {
      if (selectedKeys.length === 1 && selectedKeys[0] === 'ALL') {
        selectedKeys = this.props.items.map((o) => o.key);
      }

      if (selectedKeys.length === options.length - 1 && options.length !== 1) {
        selectedKeys.unshift('ALL');
      }
    }

    return (
      <Dropdown
        label={this.props.label}
        placeholder={this.props.placeholder}
        selectedKeys={selectedKeys}
        disabled={this.props.disabled}
        required={this.props.required}
        onChange={this.onChangeMultiSelect}
        onRenderItem={(props, defaultRender) =>
          props?.itemType === DropdownMenuItemType.Header ? (
            <div style={{ paddingLeft: (props as any).level * 20 }} onClick={(e) => this.onChangeMultiSelect(e, props)}>
              {defaultRender!(props)}
            </div>
          ) : (
            <div style={{ paddingLeft: (props as any).level * 20 }}>{defaultRender!(props)}</div>
          )
        }
        multiSelect={true}
        options={options}
        onRenderTitle={this.onRenderTitle}
        styles={{ root: this.props.styles }}
        data-tid={this.props.testId}
      />
    );
  }

  public onChangeMultiSelect = (event: React.FormEvent<HTMLDivElement>, item?: IDropdownOption) => {
    if (!item) {
      return;
    }

    if (item.key === 'ALL') {
      if (item.selected) {
        this.props.onChange(this.props.items.map((i) => i.key));
      } else {
        this.props.onChange([]);
      }
      return;
    }

    let updatedSelectedItem = (this.props.selectedKeys || []).slice();

    if (item.itemType === DropdownMenuItemType.Header) {
      const keys = (item.key as string).replace('header_', '').split('_');
      if (_.intersection(keys, this.props.selectedKeys).length === keys.length) {
        // unselect all
        updatedSelectedItem = _.difference(this.props.selectedKeys, keys);
      } else {
        updatedSelectedItem.push(...keys);
      }
    } else {
      if (item.selected) {
        // add the option if it's checked
        updatedSelectedItem.push(item.key as string);
      } else {
        // remove the option if it's unchecked
        const currIndex = updatedSelectedItem.indexOf(item.key as string);
        if (currIndex > -1) {
          updatedSelectedItem.splice(currIndex, 1);
        }
      }
    }

    this.props.onChange(_.uniq(updatedSelectedItem));
  };

  private onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    let displayTxt;
    const item = options || [];
    if (item.length === 0) {
      displayTxt = 'None selected';
    } else if (item[0].key === 'ALL') {
      displayTxt = 'All selected';
    } else if (item.length === 1) {
      displayTxt = item[0].text;
    } else {
      displayTxt = item.length + ' selected';
    }

    return <span>{displayTxt}</span>;
  };
}
